<script>
export default {
  methods: {
    deviceIsDevice () {
      return navigator.userAgent.indexOf('Mobi') > 0
    },
    deviceSetFocus () {
      if (!this.deviceIsDevice()) {
        this.$refs.focus.focus()
      }
    }
  }
}
</script>
